import { Route } from 'react-router-dom';
import { SetupWizardPage } from './pages/SetupWizardPage.js';

/**
 * Setup — license setup wizard. Drops the legacy `[...path]` API
 * proxy entirely; status is derived from app-api state instead of
 * a wizard-managed local store.
 */
export function setupRoutes(): JSX.Element {
  return <Route path="/setup" element={<SetupWizardPage />} />;
}
